import React, { useState } from "react";
import AceEditor from "react-ace";
import Button from "@atlaskit/button/new";
import { ButtonGroup } from "@atlaskit/button";
import JSONPath from "jsonpath";
import { Flex1, Flex } from "../style";
import { getAceEditorTheme } from "../utils/aceEditorTheme";
const JSONPathTest = ({ path }) => {
  const [input, setInput] = useState("");
  const [output, setOutput] = useState("");

  const inputChange = (value) => {
    setInput(value);
  };
  const onEvaluate = () => {
    //Preventing JSON error
    try {
      const obj = JSON.parse(input);
      const output = JSONPath.query(obj, path);
      //output i jsonOutput
      setOutput(JSON.stringify(output[0], undefined, 2));
    } catch (e) {
      return false;
    }
  };

  return (
    <>
      <p />
      <p>
        Test the JSON Path by clicking click <b>Evaluate</b> button
      </p>
      <ul>
        <li>Change / paste any JSON into the left side editor.</li>
      </ul>
      <ButtonGroup>
        <Button appearance="warning" onClick={onEvaluate}>
          Evalutate
        </Button>
      </ButtonGroup>

      <p />

      <Flex>
        <Flex1>
          <AceEditor
            mode="javascript"
            onChange={inputChange}
            name="UNIQUE_ID_OF_DIV_2"
            value={input}
            theme={getAceEditorTheme()}
            editorProps={{ $blockScrolling: true }}
            width="100%"
            hight="100%"
          />
        </Flex1>
        <Flex1>
          <AceEditor
            mode="javascript"
            name="UNIQUE_ID_OF_DIV_1"
            value={output}
            theme={getAceEditorTheme()}
            readOnly={true}
            editorProps={{ blockScrolling: true }}
            width="100%"
            hight="100%"
          />{" "}
        </Flex1>
      </Flex>
    </>
  );
};
export default JSONPathTest;
